import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutLinkedMovesQuickInfoTable extends Layout {
    labelId: Label;
    labelTitle: Label;
    sourceMovementStops: DataSource;
    tableLinkedMoves: Table;
}
